import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M22.11 69.47C22.11 69.47 14.93 57.0601 25.35 44.4501C25.35 44.4501 31.14 55.61 44.35 53.55C44.35 53.55 49.45 56.8601 56.63 55.2001C56.63 55.2001 60.34 57.8901 67.99 56.6501C67.99 56.6501 70.77 63.27 67.29 67.81L73.55 73.81C73.55 73.81 78.19 69.26 78.88 62.23C78.88 62.23 86.76 52.93 85.14 36.18C83.52 19.43 73.78 16.3301 65.44 11.5801C57.1 6.83006 51.1 0.840048 36.24 2.07005C23.72 3.10005 22.57 12.82 22.57 12.82C22.57 12.82 17.93 8.48004 11.45 14.06C4.96 19.64 -4.08 38.25 4.96 52.1C4.96 52.1 4.26 66.78 15.16 74.22L22.11 69.47Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M78.21 65.7601C80.08 52.1101 77.33 38.79 62.2 28.53C50.9 20.87 51.24 12.8 42.65 9.17003C33.14 5.15003 24.89 15.0901 24.89 15.0901C24.89 15.0901 38.25 12.47 50.62 27.91C61.83 41.9 61.98 49.83 69.62 57.06C77.26 64.29 70.55 70.91 70.55 70.91"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M26.98 15.3C26.98 15.3 39.76 14.9101 43.32 28.8801C46.51 41.3901 52.35 56.07 63.03 56.62"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M40.65 19.02C40.65 19.02 46.39 22.78 48.71 33.94C51.03 45.1 56.75 52.77 65.68 53.13"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M41.1829 49.5757C41.6793 50.327 42.2377 51.0441 42.8586 51.7047C42.1935 51.0879 41.5882 50.4031 41.0531 49.6741L41.0521 49.6728C38.5329 46.265 37.2421 42.2168 36.1331 38.181C35.6221 36.2137 35.1761 34.2454 34.7302 32.2774L34.6883 32.0921C34.6739 32.0255 34.6595 31.9589 34.6452 31.8921C34.4399 30.9397 34.2317 29.9739 34.0057 29.0511L34.0058 29.0511L34.0033 29.0418C33.7402 28.05 33.4352 27.0529 33.0676 26.0829L33.0676 26.0829L33.0665 26.0799C32.7395 25.2334 32.3619 24.3987 31.9227 23.5952C32.4175 24.368 32.8491 25.1847 33.2234 26.0238L33.2234 26.0238L33.2261 26.0296C34.0528 27.8208 34.535 29.7552 35.0097 31.6594C35.038 31.7731 35.0664 31.8868 35.0947 32.0003C35.2164 32.4944 35.3366 32.9892 35.4569 33.4841C35.8283 35.0127 36.2 36.5427 36.6169 38.0589C37.1397 40.0791 37.7341 42.0643 38.4507 44.0024C39.1604 45.9487 40.0462 47.845 41.1821 49.5745L41.1829 49.5757ZM45.5992 53.9466C45.6024 53.9486 45.6057 53.9506 45.609 53.9527L45.5101 54.16C43.5801 53.2 41.9201 51.7 40.6501 49.97L45.5992 53.9466Z"
        fill={outline}
        stroke={outline}
      />
      <path
        d="M31.1501 50.6599C24.2001 46.7299 25.36 37.43 26.05 29.98C26.75 22.54 23.96 19.64 23.96 19.64C23.96 19.64 15.02 16.44 13.3 28.12C11.66 39.28 10.0601 42.8 8.20005 45.49C6.34005 48.18 3.59005 54.9199 7.53005 64.2199"
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M25.26 22.3801C25.26 22.3801 25.12 31.0101 20.95 39.2801C16.78 47.5501 7.28001 60.3701 18.17 71.1201"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M74.0487 26.7042C74.7097 26.9814 75.359 27.2904 75.9937 27.6307L75.9937 27.6307L75.9969 27.6324C78.6998 29.057 81.1203 31.1306 82.8078 33.748C84.454 36.3832 85.2877 39.5053 85.2102 42.5574L85.2101 42.5574L85.21 42.5669C85.2054 43.293 85.1593 44.0154 85.0761 44.7319C85.0915 44.0095 85.0802 43.2888 85.0392 42.5715L85.0392 42.5715L85.0386 42.563C84.9274 41.0672 84.7237 39.5529 84.2465 38.0986C83.8068 36.6681 83.2101 35.2755 82.3805 34.0094C80.7714 31.4633 78.4717 29.3956 75.9068 27.7772L75.9068 27.7772L75.9036 27.7752C75.2995 27.4004 74.6808 27.0429 74.0487 26.7042Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
